import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { RoleProvider } from "@/contexts/RoleContext";
import { WarehouseProvider } from "@/contexts/WarehouseContext";
import { AccessGate } from "@/components/AccessGate";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Voorraad from "@/pages/Voorraad";
import Producten from "@/pages/Producten";
import ProductDetail from "@/pages/ProductDetail";
import Inkoopadvies from "@/pages/Inkoopadvies";
import Bestellingen from "@/pages/Bestellingen";
import BestellingNieuw from "@/pages/BestellingNieuw";
import BestellingDetail from "@/pages/BestellingDetail";
import Leveringen from "@/pages/Leveringen";
import Magazijnen from "@/pages/Magazijnen";
import Rapportages from "@/pages/Rapportages";
import Instellingen from "@/pages/Instellingen";

export default function App() {
  return (
    <ThemeProvider>
      <AccessGate>
      <RoleProvider>
      <WarehouseProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="*" element={
              <Layout>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/voorraad" element={<Voorraad />} />
                  <Route path="/producten" element={<Producten />} />
                  <Route path="/producten/:id" element={<ProductDetail />} />
                  <Route path="/inkoopadvies" element={<Inkoopadvies />} />
                  <Route path="/bestellingen" element={<Bestellingen />} />
                  <Route path="/bestellingen/nieuw" element={<BestellingNieuw />} />
                  <Route path="/bestellingen/:id" element={<BestellingDetail />} />
                  <Route path="/leveringen" element={<Leveringen />} />
                  <Route path="/leveringen/:id" element={<Leveringen />} />
                  <Route path="/magazijnen" element={<Magazijnen />} />
                  <Route path="/rapportages" element={<Rapportages />} />
                  <Route path="/instellingen" element={<Instellingen />} />
                </Routes>
              </Layout>
            } />
          </Routes>
        </BrowserRouter>
      </WarehouseProvider>
      </RoleProvider>
      </AccessGate>
      <Toaster richColors closeButton position="top-right" />
    </ThemeProvider>
  );
}
